// dpc-push.js — Push notifications para la app del cliente DPCL
// VERSION 2026-05-29: wizard interno DESHABILITADO. El onboarding de notifs
// lo hace ahora dpc-install-gate.js (priming + recovery). Este archivo solo
// expone las funciones de subscribe/unsubscribe que dpc-install-gate llama
// vía window.pushOn / window.pushOff.

(function () {
  'use strict';

  const PUSH_VAPID_KEY = 'BDgGb7TEhhmw6qPx4x8K5ClcuTGLSfiIS1E4OYJlVpNxuRNDfxxycEaAh9TLimZJ7eSYL3XsznZ8W_AF6ixdN2U';
  const PUSH_API_BASE = 'https://drinking-partners-calendar-app.fly.dev';
  const SW_PATH = (typeof window !== 'undefined' && window.DPC_SW_URL) || '/sw.js';

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const out = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) out[i] = rawData.charCodeAt(i);
    return out;
  }
  function isStandalone() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  function getEmail() {
    return (window.user && window.user.email) || null;
  }
  async function getReg() {
    return navigator.serviceWorker.register(SW_PATH);
  }
  async function isSubscribed() {
    if (!('serviceWorker' in navigator)) return false;
    try {
      const reg = await getReg();
      return !!(await reg.pushManager.getSubscription());
    } catch (e) { console.warn('[dpc-push] check fallo:', e); return false; }
  }
  async function subscribe() {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      _toast('Tu navegador no soporta notificaciones push', 'err');
      return false;
    }
    if (isIOS() && !isStandalone()) {
      _toast('Para iPhone: instala la app primero (botón compartir → Añadir a pantalla de inicio)', 'err');
      return false;
    }
    try {
      const reg = await getReg();
      // Si el permiso YA está granted, no llamamos requestPermission de nuevo.
      // En iOS PWA standalone, requestPermission sin user gesture puede retornar
      // 'default' aunque el estado real sea 'granted', mostrando un toast falso.
      let perm = (window.Notification && Notification.permission) || 'default';
      if (perm !== 'granted') {
        perm = await Notification.requestPermission();
      }
      if (perm !== 'granted') {
        // Solo mostrar el toast si realmente no está granted (denied o default)
        if (perm === 'denied') {
          _toast('Permitir notificaciones en la configuración del navegador', 'err');
        }
        return false;
      }
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(PUSH_VAPID_KEY)
      });
      // CRÍTICO: el backend requiere email para asociar la sub al cliente.
      // Si getEmail() retorna vacío (window.user no cargado todavía), el
      // backend NO va a poder asociar y el admin va a ver "sin notifs".
      // Esperamos hasta 5s para que window.user se popule antes de mandar.
      let email = getEmail();
      if (!email) {
        console.warn('[dpc-push] subscribe: email vacío al inicio, esperando 5s a que window.user cargue…');
        for (let i = 0; i < 25 && !email; i++) {
          await new Promise(r => setTimeout(r, 200));
          email = getEmail();
        }
      }
      if (!email) {
        console.error('[dpc-push] subscribe: NO se obtuvo email después de 5s — la sub no se va a asociar a un cliente');
        // No abortamos — mandamos igual con email vacío y el backend hace lo posible
      }
      // Reintentos con backoff para el POST al backend (cubre network glitch / 5xx)
      let lastErr = null;
      let okBackend = false;
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const r = await fetch(PUSH_API_BASE + '/api/push-subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              subscription: sub.toJSON(),
              role: 'customer',
              email,
              userAgent: navigator.userAgent.slice(0, 300)
            })
          });
          if (r.ok) { okBackend = true; break; }
          lastErr = new Error('Backend rechazó (HTTP ' + r.status + ')');
          console.warn('[dpc-push] backend ' + r.status + ' attempt ' + (attempt + 1) + '/3');
        } catch (netErr) {
          lastErr = netErr;
          console.warn('[dpc-push] network error attempt ' + (attempt + 1) + '/3:', netErr?.message);
        }
        // Backoff 500ms / 1500ms antes de reintentar
        if (attempt < 2) await new Promise(r => setTimeout(r, attempt === 0 ? 500 : 1500));
      }
      if (!okBackend) throw lastErr || new Error('Backend no respondió');
      _toast('✓ Notificaciones activadas', 'ok');
      return true;
    } catch (e) {
      console.error('[dpc-push] subscribe falló:', e);
      _toast('No pude activar: ' + e.message, 'err');
      return false;
    }
  }
  async function unsubscribe() {
    try {
      const reg = await getReg();
      const sub = await reg.pushManager.getSubscription();
      if (!sub) return;
      const endpoint = sub.endpoint;
      await sub.unsubscribe();
      await fetch(PUSH_API_BASE + '/api/push-unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ endpoint })
      });
      _toast('Notificaciones desactivadas', 'ok');
    } catch (e) { console.error('[dpc-push] unsubscribe falló:', e); }
  }
  async function toggle() {
    if (await isSubscribed()) {
      await unsubscribe();
      if (typeof window.perfil === 'function') window.perfil();
    } else {
      // El wizard de onboarding ahora lo maneja dpc-install-gate.js
      // Si por alguna razón se llama a toggle() y no está suscrito, intentamos
      // subscribe directo (asume que ya hubo user gesture).
      await subscribe();
      if (typeof window.perfil === 'function') window.perfil();
    }
  }

  // showOnboarding / checkOnboardingNow / autoMaybeShowOnboarding son NO-OPs.
  // Se mantienen como stubs por si código legacy los llama.
  function showOnboarding() {
    console.log('[dpc-push] showOnboarding DESHABILITADO — usa dpc-install-gate.js');
  }
  function checkOnboardingNow() {
    // Backfill silencioso del email en la sub existente (sin mostrar wizard)
    setTimeout(async () => {
      try {
        const isSubbed = await isSubscribed();
        const hasUserEmail = !!(window.user && window.user.email);
        if (isSubbed && hasUserEmail) {
          const reg = await getReg();
          const sub = reg ? await reg.pushManager.getSubscription() : null;
          if (sub) {
            await fetch(PUSH_API_BASE + '/api/push-subscribe', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                subscription: sub.toJSON(),
                role: 'customer',
                email: window.user.email,
                userAgent: navigator.userAgent.slice(0, 300),
              }),
            });
            console.log('[dpc-push] backfill email en sub existente:', window.user.email);
          }
        }
      } catch (e) { console.warn('[dpc-push] backfill email falló:', e && e.message); }
    }, 500);
  }
  // Listener al login: solo hace el backfill silencioso, NO muestra wizard
  window.addEventListener('dpcLogin', checkOnboardingNow);

  function _toast(msg, kind) {
    if (typeof window.toast === 'function') window.toast(msg, kind);
    else console.log('[dpc-push] ' + (kind === 'err' ? 'ERROR: ' : '') + msg);
  }

  // Auto-registro del SW al cargar (no pide permiso, solo prepara)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(SW_PATH).catch((e) => {
      console.warn('[dpc-push] SW register falló:', e);
    });
    // Listener navegación desde push notif
    navigator.serviceWorker.addEventListener('message', (e) => {
      if (!(e.data && e.data.type === 'navigate' && e.data.url)) return;
      const url = String(e.data.url);
      const tabMap = { reservas: 1, carrito: 2, carrete: 3, perfil: 4, catalogo: 5, inicio: 0 };
      const mTab = url.match(/#([a-z]+)/);
      if (mTab && tabMap[mTab[1]] !== undefined && typeof window.setNav === 'function') {
        window.setNav(tabMap[mTab[1]]);
      }
      const mOrder = url.match(/[?&#]order=([^&]+)/);
      if (mOrder) {
        const oid = decodeURIComponent(mOrder[1]);
        setTimeout(() => {
          const el = document.querySelector(`[data-order-id="${oid}"]`);
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 300);
      }
    });
  }

  // API pública
  window.dpcPush = {
    subscribe: subscribe,
    unsubscribe: unsubscribe,
    isSubscribed: isSubscribed,
    toggle: toggle,
    showOnboarding: showOnboarding,
    checkOnboardingNow: checkOnboardingNow
  };
  window.pushOn = subscribe;
  window.pushOff = unsubscribe;
  window.pushIsOn = isSubscribed;
  window.togglePush = toggle;

  // Mata cualquier overlay legacy que haya quedado del wizard viejo cacheado
  function killLegacyOverlays() {
    ['dpc-push-onboard', 'dpc-ob-overlay'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) { el.remove(); console.log('[dpc-push] overlay legacy eliminado:', id); }
    });
  }
  killLegacyOverlays();
  setInterval(killLegacyOverlays, 1000);

  // ===========================================================================
  // AUTO-RECOVERY: si Notification.permission === 'granted' pero NO hay
  // subscripción registrada (ni local en el SW, ni en backend), re-suscribimos
  // silenciosamente. Esto cubre clientes que cayeron en el bug viejo donde
  // requestPermission sin user gesture retornaba 'default' y abortaba subscribe.
  //
  // - Solo en standalone (PWA instalada) — sino no tiene sentido suscribir.
  // - Solo si hay email de usuario (loggedIn) — sin email no se puede registrar.
  // - Silencioso: no muestra toasts, sin importar el resultado.
  // - Espera 3s después del load para no pelear con otros scripts.
  // - Idempotente: si ya hay subscripción local, no hace nada (subscribe es
  //   idempotente igual, pero evitamos network innecesario).
  // ===========================================================================
  async function autoRecoverIfNeeded() {
    try {
      if (!isStandalone()) return;
      if (!('Notification' in window)) return;
      if (Notification.permission !== 'granted') return;
      // Email de usuario — sin esto no podemos registrar
      const email = getEmail();
      if (!email) return;
      // ¿Ya hay subscripción local? Si sí, asumimos que está sincronizada
      const already = await isSubscribed();
      if (already) {
        console.log('[dpc-push] auto-recovery: ya hay subscripción local, skip');
        return;
      }
      console.log('[dpc-push] auto-recovery: permission=granted sin subscripción → re-suscribiendo silenciosamente');
      // Subscribe silencioso — capturamos errores para no mostrar toasts
      const origToast = window._toast || window.toast;
      try {
        // Pasar toast a no-op solo durante este subscribe (otros scripts pueden estar suscritos al toast)
        // En realidad subscribe() usa _toast del closure, no podemos mockearlo. Lo dejamos.
        const ok = await subscribe();
        console.log('[dpc-push] auto-recovery result:', ok);
      } catch (e) {
        console.warn('[dpc-push] auto-recovery falló:', e?.message || e);
      }
    } catch (e) {
      console.warn('[dpc-push] auto-recovery error:', e);
    }
  }
  // Disparar 3s después del load + al volver a la pestaña (visibilitychange)
  setTimeout(autoRecoverIfNeeded, 3000);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      setTimeout(autoRecoverIfNeeded, 1500);
    }
  });
  window.addEventListener('dpcLogin', () => setTimeout(autoRecoverIfNeeded, 1500));

  console.log('[dpc-push] cargado v2026-05-30 (auto-recovery activado)');
})();
